export default "__VITE_ASSET__01661a5f__"